
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Frais from "../../components/frais";
import Recap from "../../components/recapPresta";
import ServicesRdv from "../../components/services";
import "../../assets/EtablissementServices.scss";
import Layout from "./layout";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { addSelectedPrestation, clearSelectedPrestations, resetDetailsRDV } from "../../store/slices/rendezVousSlice";
import { fetchEtablissementById, setSelectedEtablissement } from "../../store/slices/etablissementSlice";
import { useEffect } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

const InfoPrestations=()=>{
    const {id}=useParams()
    const navigate=useNavigate()
    const dispatch=useDispatch()
    const etablissement=useSelector((state)=>state.etablissements.selectedEtablissement)
    const { selectedPrestations } = useSelector((state) => state.rendezvous);
    // console.log(selectedPrestations)
    const buttonAction=(prestation)=>{
        dispatch(clearSelectedPrestations())
         
         dispatch(addSelectedPrestation(
            prestation
          ));
          dispatch(setSelectedEtablissement(etablissement))
        navigate(`/details-rdv/${etablissement.id}`)
       
    }
     //useEffect
      useEffect(() => {
            dispatch(fetchEtablissementById(id))
        
      }, []);
        useEffect(() => {
          return () => {
            dispatch(resetDetailsRDV());
          };
        }, []);
return(
    <>
     
      <Layout currentStep={1} etablissement={etablissement} recap={true} conf={true} btn={false} from='reservation' >
     <HelmetProvider> <Helmet>
                                    <title>Page réservation prestataire par service</title>
                                    <meta name="description" content="Page réservation , prendre rendez-vous avec prestataire" />
                              
                                </Helmet>
                                </HelmetProvider>
     <ServicesRdv services={etablissement?.services} buttonAction={buttonAction}/>
      
    </Layout>
    </>
)
}
export default InfoPrestations;